import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import i18n from "i18next";

interface LanguageState {
    currentLanguage: string;
}

const initialState: LanguageState = {
    currentLanguage: "en", // Язык по умолчанию
};

export const language_slice = createSlice({
    name: "language",
    initialState,
    reducers: {
        setLanguage: (state, action: PayloadAction<string>) => {
            state.currentLanguage = action.payload;
            i18n.changeLanguage(action.payload); // Меняем язык в i18next
        },
    },
});

export const {setLanguage} = language_slice.actions;
export default language_slice;
// export default language_slice.reducer;